import { FindTime } from "@clockwise/design-system/icons";
import { fg_onEmphasis } from "@clockwise/design-system/tokens";
import { ExternalLinkButton } from "@clockwise/web-commons/src/ui/external-link-button";
import { TrackingEvents, useTracking } from "@clockwise/web-commons/src/util/analytics.util";
import { getUrlForFeature } from "@clockwise/web-commons/src/util/routes.util";
import classNames from "classnames";
import { nanoid } from "nanoid";
import React from "react";

const FindTimeIcon = () => <FindTime fill={fg_onEmphasis} />;

export function FloatingScheduleButton() {
  const aiUrl = getUrlForFeature("ai");
  const track = useTracking();

  const onClick = () => {
    const schedulingSessionId = nanoid();
    track(TrackingEvents.SCHEDULING.FEED_SCHEDULER_EXPANDED, {
      schedulingSessionId,
    });
  };

  return (
    <div className={classNames("cw-fixed cw-right-0 cw-bottom-0 cw-z-[11] cw-p-3 cw-w-[300px]")}>
      <div className="cw-rounded-full cw-drop-shadow-lg">
        <ExternalLinkButton
          cw-id="sidebar-schedule-meeting"
          fullWidth
          onLinkOpen={onClick}
          sentiment="positive"
          size="medium"
          startIcon={FindTimeIcon}
          url={aiUrl}
        >
          Schedule meeting
        </ExternalLinkButton>
      </div>
    </div>
  );
}
